import { DatePipe } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { SettingsService } from '../../services/settings.service';
import { TopWinnersService } from '../../services/top-winners.service';
import { BettingSlipModalComponent } from '../betting-slip-popup/betting-slip-modal.component';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { Store } from '@ngrx/store';
import { selectGeneralSettingsData } from 'src/app/store/general-settings/general-settings.selectors';

@Component({
  selector: 'app-top-wining',
  templateUrl: './top-wining.component.html',
  styleUrls: ['./top-wining.component.scss'],
  providers: [DatePipe, DialogService],
})
export class TopWiningComponent implements OnInit {
  @Input() collapsed = false;
  showTopWinnings = true;
  winningCoupons = [];
  //Test Data dd
  // winningCoupons = [
  //   {
  //     user: {
  //       username: 'Test User'
  //     },
  //     betslip: {
  //       winnigs: 155556
  //     }
  //   },

  //   {
  //     user: {
  //       username: 'Test User'
  //     },
  //     betslip: {
  //       winnigs: 155556
  //     }
  //   }
  // ];

  showModal = false;
  ref: DynamicDialogRef;

  constructor(
    public dialogService: DialogService,
    private store: Store,
    private topWinnerService: TopWinnersService,
    private settingService: SettingsService,
    public authService: AuthService
  ) {}

  ngOnInit(): void {
    this.getSetting();
  }
  getSetting() {
    this.store.select(selectGeneralSettingsData).subscribe((res) => {
      this.showTopWinnings = res.showTopWinnings;
      if (res.showTopWinnings) {
        this.getTopWinners();
      }
    });
    // this.settingService.getGeneralSettings().subscribe((data) => {
    //   this.showTopWinnings = data.showTopWinnings;
    //   if (data.showTopWinnings) {
    //     this.getTopWinners();
    //   }
    // });
  }

  getTopWinners(): any {
    this.topWinnerService.getTopWinners().subscribe((data) => {
      if (data?.data?.length > 0) {
        this.winningCoupons = data?.data?.sort(
          (n1, n2) => n2.betslip.winnings - n1.betslip.winnings
        );
      }
    });
  }

  raceDetail(raceDetail) {
    this.ref = this.dialogService.open(BettingSlipModalComponent, {
      showHeader: false,
      dismissableMask: true,
      width: '50vw',
      contentStyle: { 'max-height': '90%', overflow: 'auto', padding: '0' },
      baseZIndex: 10000,
      styleClass: 'bet-detail-modal',
      data: {
        couponId: raceDetail.coupon.id,
        raceId: raceDetail.betslip.raceId,
        hidePrint: true,
        topCoupon: true,
      },
    });
  }
}
